function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-bottom: 1px solid ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import styled, { useTheme } from "styled-components";
import getExternalLinkProps from "../../util/getExternalLinkProps";
import Grid from "../../components/Box/Grid";
import Box from "../../components/Box/Box";
import getThemeValue from "../../util/getThemeValue";
import Text from "../../components/Text/Text";
import Heading from "../../components/Heading/Heading";
import { Button } from "../../components/Button";
import { ModalBody, ModalCloseButton, ModalContainer, ModalHeader, ModalTitle } from "../Modal";
import WalletCard, { MoreWalletCard } from "./WalletCard";
import config, { walletLocalStorageKey } from "./config";
var WalletWrapper = styled(Box).withConfig({
    componentId: "sc-ecfa10f7-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var getPriority = function(priority) {
    return typeof priority === "function" ? priority() : priority;
};
/**
 * Checks local storage if we have saved the last wallet the user connected with
 * If we find something we put it at the top of the list
 *
 * @returns sorted config
 */ var getPreferredConfig = function(walletConfig) {
    var sortedConfig = walletConfig.sort(function(a, b) {
        return getPriority(a.priority) - getPriority(b.priority);
    });
    var preferredWalletName = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(walletLocalStorageKey);
    if (!preferredWalletName) {
        return sortedConfig;
    }
    var preferredWallet = sortedConfig.find(function(sortedWalletConfig) {
        return sortedWalletConfig.title === preferredWalletName;
    });
    if (!preferredWallet) {
        return sortedConfig;
    }
    return [
        preferredWallet, 
    ].concat(_toConsumableArray(sortedConfig.filter(function(sortedWalletConfig) {
        return sortedWalletConfig.title !== preferredWalletName;
    })));
};
var ConnectModal = function(param) {
    var login = param.login, _onDismiss = param.onDismiss, onDismiss = _onDismiss === void 0 ? function() {
        return null;
    } : _onDismiss, _displayCount = param.displayCount, displayCount = _displayCount === void 0 ? 3 : _displayCount, t = param.t;
    var ref;
    var ref1 = useState(false), showMore = ref1[0], setShowMore = ref1[1];
    var theme = useTheme();
    var sortedConfig = getPreferredConfig(config);
    // Filter out WalletConnect if user is inside TrustWallet built-in browser
    var walletsToShow = ((ref = window.ethereum) === null || ref === void 0 ? void 0 : ref.isTrust) ? sortedConfig.filter(function(wallet) {
        return wallet.title !== "WalletConnect";
    }) : sortedConfig;
    var displayListConfig = showMore ? walletsToShow : walletsToShow.slice(0, displayCount);
    return /*#__PURE__*/ _jsxs(ModalContainer, {
        "aria-label": t("Connect Wallet"),
        minWidth: "320px",
        children: [
            /*#__PURE__*/ _jsxs(ModalHeader, {
                background: getThemeValue("colors.gradients.bubblegum")(theme),
                children: [
                    /*#__PURE__*/ _jsx(ModalTitle, {
                        children: /*#__PURE__*/ _jsx(Heading, {
                            children: t("Connect Wallet")
                        })
                    }),
                    /*#__PURE__*/ _jsx(ModalCloseButton, {
                        onDismiss: onDismiss
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs(ModalBody, {
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        color: "textSubtle",
                        fontSize: "14px",
                        px: "24px",
                        pt: "20px",
                        children: t("Choose a wallet to connect to CRP Swap.")
                    }),
                    /*#__PURE__*/ _jsx(WalletWrapper, {
                        p: "24px",
                        overflowY: "auto",
                        children: /*#__PURE__*/ _jsxs(Grid, {
                            gridTemplateColumns: "1fr 1fr",
                            gridGap: "12px",
                            children: [
                                displayListConfig.map(function(wallet) {
                                    return /*#__PURE__*/ _jsx(Box, {
                                        children: /*#__PURE__*/ _jsx(WalletCard, {
                                            walletConfig: wallet,
                                            login: login,
                                            onDismiss: onDismiss
                                        })
                                    }, wallet.title);
                                }),
                                !showMore && /*#__PURE__*/ _jsx(MoreWalletCard, {
                                    t: t,
                                    onClick: function() {
                                        return setShowMore(true);
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "hidden",
                        children: /*#__PURE__*/ _jsxs(Box, {
                            p: "24px",
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    textAlign: "center",
                                    color: "textSubtle",
                                    as: "p",
                                    mb: "16px",
                                    children: t("Haven\u2019t got a crypto wallet yet?")
                                }),
                                /*#__PURE__*/ _jsx(Button, _objectSpread({
                                    as: "a",
                                    href: "https://docs.pancakeswap.finance/get-started/connection-guide",
                                    variant: "subtle",
                                    width: "100%"
                                }, getExternalLinkProps(), {
                                    children: t("Learn How to Connect")
                                }))
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
export default ConnectModal;
